import { ContentType } from "../enums/contentStack.js";
import { getConfigurationSettingByDevelopmentKey } from "../services/content/config.lib.js";
const getFeatureFlagState = async (featureKey, appName) => {
  var _a, _b, _c, _d, _e;
  let flagState = {
    isEnabled: false,
    lastUpdated: null
  };
  try {
    const featureResponse = await getConfigurationSettingByDevelopmentKey(
      ContentType.FeatureToggle,
      featureKey
    );
    flagState = {
      isEnabled: Boolean(featureResponse.feature_on),
      lastUpdated: featureResponse.updated_at ? new Date(featureResponse.updated_at) : null
    };
    if (!appName || !process.env.SITE || !((_b = (_a = featureResponse.enabled_applications) == null ? void 0 : _a.applications) == null ? void 0 : _b.length)) {
      return flagState;
    }
    const site = process.env.SITE;
    const application = `${appName.toLowerCase()}-${site.toLowerCase()}`;
    if (((_d = (_c = featureResponse.enabled_applications) == null ? void 0 : _c.applications) == null ? void 0 : _d.length) > 0 && !featureResponse.enabled_applications.applications.includes(
      application.toLowerCase()
    )) {
      flagState = {
        isEnabled: false,
        lastUpdated: null
      };
    }
    return flagState;
  } catch {
    console.error(
      `Error fetching feature flag: "${featureKey}" for application: "${appName == null ? void 0 : appName.toLowerCase()}-${(_e = process.env.SITE) == null ? void 0 : _e.toLowerCase()}"`
    );
    return flagState;
  }
};
export {
  getFeatureFlagState
};
